// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabel":"Checkbox_checkboxLabel__361Ku","input":"Checkbox_input__2NO9x"};